import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AUTH_ENDPOINTS } from '../../api';
import './Login.css';

const Login = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(AUTH_ENDPOINTS.LOGIN, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok && data.status === 'success') {
        // Store token in localStorage
        localStorage.setItem('authToken', data.data.token);
        localStorage.setItem('user', JSON.stringify(data.data.user));
        
        // Call the onLogin callback
        if (onLogin) {
          onLogin(data.data);
        }
        
        // Navigate to the main application
        navigate('/capital-expenditure/data-view');
      } else {
        setError(data.message || 'Login failed');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h2>लगइन गर्नुहोस्</h2>
          <p>आफ्नो खातामा लगइन गर्नुहोस्</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <label htmlFor="username">प्रयोगकर्ता नाम</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              placeholder="आफ्नो प्रयोगकर्ता नाम लेख्नुहोस्"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">पासवर्ड</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="आफ्नो पासवर्ड लेख्नुहोस्"
            />
          </div>
          
          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? 'लगइन हुँदै...' : 'लगइन गर्नुहोस्'}
          </button>
        </form>
        
        <div className="login-footer">
          <p>नयाँ प्रयोगकर्ता? <a href="/register">खाता सिर्जना गर्नुहोस्</a></p>
        </div>
      </div>
    </div>
  );
};

export default Login;
